export type Menu = {
  name: string;
  iconClass: string;
  active: boolean;
  displayItems?: any[];
  submenu: Submenu[];
};

export type Submenu = {
  name: string;
  url: string;
};
